import type { IEItem, IEMBuyProgramCatalogItem } from '@/services/iem';

/**
 * Extracts catalog IDs from IE Kit items into a Set for efficient lookup.
 */
export const extractAuthorizedCatalogIds = (ieItems: IEItem[]): Set<string> => {
  const ids = new Set<string>();
  ieItems.forEach((item) => {
    if (item.catalogId) {
      ids.add(item.catalogId);
    }
  });
  return ids;
};

/**
 * Filters Buy Program catalog items to only include those authorized via IE Kit.
 */
export const filterAuthorizedBuyProgramItems = (
  buyProgramItems: IEMBuyProgramCatalogItem[],
  authorizedCatalogIds: Set<string>,
): IEMBuyProgramCatalogItem[] => {
  if (authorizedCatalogIds.size === 0) return [];
  return buyProgramItems.filter((item) => authorizedCatalogIds.has(item.id));
};
